import { useEffect } from 'react';

/**
 * Custom hook to set the page title
 * @param {string} title - The page title (without the app suffix)
 * @example usePageTitle("Sign In") // Sets title to "Sign In - Ultimate Web Scraper Cloud"
 */
export function usePageTitle(title) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title
      ? `${title} - Ultimate Web Scraper Cloud`
      : 'Ultimate Web Scraper Cloud';

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
}
